module.exports = __webpack_public_path__ + "static/media/ic_calendar_small.bd20349a.svg";